// extracted by mini-css-extract-plugin
module.exports = {"center":"EmailCategory_center__SDlRl"};